export const MINIMUM_REPLENISH_AMOUNT_USD = 25;
export const MINIMUM_REPLENISH_AMOUNT_DAYS = 1;
